module.exports = __webpack_public_path__ + "img/slide_bg_05.46918c37.png";